import { render } from "./LbrxPrivacyPolicy.vue?vue&type=template&id=c7be1876&scoped=true"
import script from "./LbrxPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./LbrxPrivacyPolicy.vue?vue&type=script&lang=js"

import "./LbrxPrivacyPolicy.vue?vue&type=style&index=0&id=c7be1876&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7be1876"]])

export default __exports__